import { Skeleton } from '@mantine/core'
import React from 'react'

const SkeletonGroup = ({ height, width, num }) => {
  return (
    <>
      {
        Array.from(Array(num)).map((_, idx) => <Skeleton height={height} width={width} key={idx} />)
      }
    </>
  )
}

export default SkeletonGroup